import React from 'react';

import { useStyles } from './styles';

export const LoadingPlaceholder = ({
  width
}: LoadingPlaceholderProps) => {
  const classes = useStyles({ width });

  return (
    <div className={classes.container} />
  );
};

export interface LoadingPlaceholderProps {
  width?: 'auto' | number;
}
